import React from "react";
import PropTypes from "prop-types";

const FuelTooltip = ({ data, lang }) => {
  let orange = {
    color: "#FF9100"
  };

  let tanques;
  if (data !== null) {
    if (
      data.hasOwnProperty("TanquesCombustible") &&
      data.TanquesCombustible != null
    ) {
      tanques = data.TanquesCombustible.filter(x => x >= 0).map(
        (tank, index) => (
          <div key={index}>
            <span style={orange}>{"T" + (index + 1) + ": "}</span>
            {(tank / 100).toFixed(0)}
          </div>
        )
      );
    }
  }

  let eventoString;
  let eventoTag;
  let iconString;
  let iconTag;

  if (data !== null) {
    if (data.Evento !== 0) {
      eventoString = lang["Event" + data.Evento];
      iconString = `../images/${data.Evento}.svg`;
    } else {
      if (data.Velocidad === 0) {
        eventoString = lang.Detenido;
        iconString = `../images/iconosconfigurables/camión_detenido.svg`;
      } else {
        eventoString = lang.Movimiento;
        iconString = `../images/iconosconfigurables/camión_moviendo.svg`;
      }
    }

    eventoTag = <div style={orange}>{eventoString}</div>;
  }

  iconTag = <img src={iconString} style={{ height: "40px", width: "40px" }} />;

  let fechaString = data.Fecha.replace("T", " ");

  return (
    <div>
      {eventoTag}
      {iconTag}
      <div style={orange}>{lang.Fecha + ":"}</div>
      <div>{fechaString}</div>
      <div>{tanques}</div>
      <div>
        <span style={orange}>{"Total: "}</span> {data.Volumen}
      </div>
    </div>
  );
};

FuelTooltip.propTypes = {
  data: PropTypes.object.isRequired,
  lang: PropTypes.object.isRequired
};

export default FuelTooltip;



// WEBPACK FOOTER //
// ./src/charts/FuelTimeseries/FuelTimeseriesTooltip.js